module.exports = __webpack_public_path__ + "media/application/images/partners/wjc@2x-2e796a42209ade7fe97520bced7a464d71f172491d7d004495b450aac4b86618.png";